import { useEffect } from 'react';
import { useSelector } from '@legendapp/state/react';
import { ui$ } from '@/stores/ui$';

const THEME_COLORS = {
  light: '#ffffff',
  dark: '#0c1222'
};

export function useThemeColor() {
  const theme = useSelector(() => ui$.theme.get());

  // Effect 1: Update theme-color when theme changes
  useEffect(() => {
    const resolvedTheme = theme === 'system'
      ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
      : theme;

    updateMetaThemeColor(resolvedTheme);
  }, [theme]);

  // Effect 2: Listen for system preference changes (only when theme === 'system')
  useEffect(() => {
    if (theme !== 'system') return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      const resolvedTheme = mediaQuery.matches ? 'dark' : 'light';
      updateMetaThemeColor(resolvedTheme);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [theme]);
}

function updateMetaThemeColor(resolvedTheme) {
  const color = THEME_COLORS[resolvedTheme];

  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.content = color;
}
